import React from 'react'
import PropTypes from 'prop-types'
import toUpper from 'lodash/toUpper'

// Components
import Button from 'ui/Button'
import Dropdown from 'ui/Dropdown'
import DropdownMenu from 'ui/Dropdown/DropdownMenu'
import DropdownMenuItem from 'ui/Dropdown/DropdownMenuItem'

export const ButtonDownload = ({
  extentions,
  button,
  children,
  onClick,
  disabled,
  ...props
}) => {
  const Toggle = () => {
    if (button) {
      return (
        <Button disabled={disabled} {...props}>
          {children}
        </Button>
      )
    }

    return { children }
  }

  const DownloadMenu = () => {
    return (
      <DropdownMenu onClick={({ key }) => onClick(key)}>
        {extentions.map((extention) => {
          return (
            <DropdownMenuItem key={extention}>
              {toUpper('.' + extention)}
            </DropdownMenuItem>
          )
        })}
      </DropdownMenu>
    )
  }

  return (
    <Dropdown
      overlay={DownloadMenu}
      trigger={['click']}
      disabled={disabled}
      {...props}
    >
      <div>
        <Toggle />
      </div>
    </Dropdown>
  )
}

ButtonDownload.propTypes = {
  extentions: PropTypes.array,
  button: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.any,
  disabled: PropTypes.bool,
}

ButtonDownload.defaultProps = {
  extentions: ['xlsx', 'csv', 'pdf'],
  button: true,
  onClick: () => {},
  children: null,
  disabled: false,
}

export default ButtonDownload
